@if (ready) {
  <div class="persona-avatar">
    <se-fe-header
      (click)="onChosen($event)"
      (keydown)="onKeydown($event)" tabindex="0"
      class="panel-trigger"
      [seFeDataTitle]="!headerLink && title"
      [seFeDataSubtitle]="!isGuardian && subtitle"
      [seFeDataLevel]="0"
      [seFeDataSize]="600">
      <se-fe-avatar
        seFeHeaderVisual
        seFeDataType="persona"
        [seFeDataIdentity]="title"
        [seFeDataImgUrl]="imageUrl"
        [seFeDataSize]="500">
      </se-fe-avatar>
      <!-- guardian subtitle is separated out so that email can be ellipsis truncated if it overflows in mobile -->
      @if (isGuardian) {
        <div seFeHeaderSubtitle class="persona-subtitle">
          {{ subtitle }}
        </div>
      }
      @if (headerLink) {
        <a seFeHeaderTitle class="persona-avatar-link" [href]="headerLink">{{ title }}</a>
      }
    </se-fe-header>
    @if (menuOptions) {
      <div (click)="onActionClick($event)" class="menu-trigger">
        <se-fe-icon-button [seFeMenuTrigger]="householdMenu">
          <se-fe-icon
            seFeDataName="more"
            seFeDataSize="700"
            seFeDataColor="gray-700"
            seFeDataAriaLabel="more">
          </se-fe-icon>
        </se-fe-icon-button>
        <se-fe-menu
          #householdMenu
          [seFeDataOptions]="menuOptions">
        </se-fe-menu>
      </div>
    }
  </div>
}
